// Customer Cases V2 — data-testid registry.
export const CASES_V2 = {
  navCases: "nav-cases",

  // List page
  page: "cases-v2-page",
  listTable: "cases-v2-table",
  listRow: (id) => `cases-v2-row-${id}`,
  searchInput: "cases-v2-search-input",
  statusFilter: "cases-v2-status-filter",
  newBtn: "cases-v2-new-btn",
  refreshBtn: "cases-v2-refresh-btn",

  // New Case page
  newPage: "case-v2-new-page",
  createdByLabel: "case-v2-created-by",
  customerSource: "case-v2-customer-source",
  customerType: "case-v2-customer-type",
  customerTypeAlready: "case-v2-customer-type-already-bought",
  customerTypePaid: "case-v2-customer-type-paid",
  customerSearchInput: "case-v2-customer-search-input",
  customerSearchResult: (id) => `case-v2-customer-search-result-${id}`,
  customerSearchEmpty: "case-v2-customer-search-empty",
  customerSearchClear: "case-v2-customer-search-clear",
  warrantyPreview: "case-v2-warranty-preview",
  customerName: "case-v2-customer-name",
  mobile: "case-v2-mobile",
  altMobile: "case-v2-alt-mobile",
  email: "case-v2-email",
  companyName: "case-v2-company-name",
  gst: "case-v2-gst",
  address: "case-v2-address",
  city: "case-v2-city",
  state: "case-v2-state",
  pincode: "case-v2-pincode",
  brand: "case-v2-brand",
  model: "case-v2-model",
  serial: "case-v2-serial",
  processor: "case-v2-processor",
  ram: "case-v2-ram",
  storage: "case-v2-storage",
  generation: "case-v2-generation",
  chargerIncluded: "case-v2-charger-included",
  complaint: "case-v2-complaint",
  hasBatteryProblem: "case-v2-has-battery-problem",
  passwordProtected: "case-v2-password-protected",
  submit: "case-v2-submit",
  cancel: "case-v2-cancel",

  // Detail page tabs
  detailPage: "case-v2-detail-page",
  detailHeader: "case-v2-detail-header",
  detailStatusPill: "case-v2-status-pill",
  tabOverview: "case-v2-tab-overview",
  tabContents: "case-v2-tab-contents",
  tabCondition: "case-v2-tab-condition",
  tabSerial: "case-v2-tab-serial",
  tabPassword: "case-v2-tab-password",
  tabPhotos: "case-v2-tab-photos",
  tabReversePickup: "case-v2-tab-reverse-pickup",
  tabWorkflow: "case-v2-tab-workflow",
  tabDispatch: "case-v2-tab-dispatch",
  tabPrint: "case-v2-tab-print",
  tabTimeline: "case-v2-tab-timeline",

  // Contents
  contentAddBtn: "case-v2-content-add",
  contentTypeSelect: (i) => `case-v2-content-type-${i}`,
  contentCustom: (i) => `case-v2-content-custom-${i}`,
  contentQty: (i) => `case-v2-content-qty-${i}`,
  contentRemarks: (i) => `case-v2-content-remarks-${i}`,
  contentRemove: (i) => `case-v2-content-remove-${i}`,
  contentSave: "case-v2-content-save",

  // Condition
  conditionOverall: (v) => `case-v2-condition-overall-${v}`,
  conditionIssue: (label) => `case-v2-condition-issue-${label}`,
  conditionRemarks: "case-v2-condition-remarks",
  conditionSave: "case-v2-condition-save",

  // Serial
  powerStatus: (v) => `case-v2-power-status-${v}`,
  serialInput: "case-v2-serial-input",
  serialSave: "case-v2-serial-save",

  // Password
  passwordWin: "case-v2-pwd-win",
  passwordPin: "case-v2-pwd-pin",
  passwordBios: "case-v2-pwd-bios",
  passwordRemarks: "case-v2-pwd-remarks",
  passwordEye: "case-v2-pwd-eye",
  passwordSave: "case-v2-pwd-save",

  // Photos
  photoAngle: "case-v2-photo-angle",
  photoUpload: "case-v2-photo-upload",
  photoItem: (i) => `case-v2-photo-${i}`,

  // Reverse pickup
  rpCourier: "case-v2-rp-courier",
  rpAwb: "case-v2-rp-awb",
  rpStatus: "case-v2-rp-status",
  rpSave: "case-v2-rp-save",

  // Workflow / assign
  assignDept: "case-v2-assign-dept",
  assignRemarks: "case-v2-assign-remarks",
  assignSave: "case-v2-assign-save",

  whStatus: "case-v2-wh-status",
  whRemarks: "case-v2-wh-remarks",
  whSerial: "case-v2-wh-serial",
  whSave: "case-v2-wh-save",

  qcResult: "case-v2-qc-result",
  qcRemarks: "case-v2-qc-remarks",
  qcBatteryToggle: "case-v2-qc-battery-toggle",
  qcSave: "case-v2-qc-save",

  batPresent: "case-v2-bat-present",
  batHealth: "case-v2-bat-health",
  batWh: "case-v2-bat-wh",
  batCycles: "case-v2-bat-cycles",
  batType: "case-v2-bat-type",
  batSave: "case-v2-bat-save",

  // Dispatch
  dispatchMode: "case-v2-dispatch-mode",
  dispatchCourierName: "case-v2-dispatch-courier-name",
  dispatchAwb: "case-v2-dispatch-awb",
  dispatchLabel: "case-v2-dispatch-label",
  dispatchPorter: "case-v2-dispatch-porter",
  dispatchUncle: "case-v2-dispatch-uncle",
  dispatchVehicle: "case-v2-dispatch-vehicle",
  dispatchSignature: "case-v2-dispatch-signature",
  dispatchRemarks: "case-v2-dispatch-remarks",
  dispatchSave: "case-v2-dispatch-save",
  markDelivered: "case-v2-mark-delivered",
  closeRemarks: "case-v2-close-remarks",
  closeBtn: "case-v2-close-btn",

  // Print
  printLabelBtn: "case-v2-print-label",
  printReceiptBtn: "case-v2-print-receipt",
  printHistoryRow: (i) => `case-v2-print-history-${i}`,

  // Timeline
  timeline: "case-v2-timeline",
  timelineRow: (i) => `case-v2-timeline-row-${i}`,
};
